import { render, staticRenderFns } from "./CompanyAttendanceCorrectionsMain.vue?vue&type=template&id=cd157a00"
import script from "./CompanyAttendanceCorrectionsMain.vue?vue&type=script&lang=js"
export * from "./CompanyAttendanceCorrectionsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports